export var SessionEndpoints;
(function (SessionEndpoints) {
    SessionEndpoints["SESSION"] = "/session";
    SessionEndpoints["SESSION_END"] = "/session/end";
})(SessionEndpoints || (SessionEndpoints = {}));
